'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _zh_CN = require('rc-time-picker/lib/locale/zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var locale = _extends({
  placeholder: '请选择时间'
}, _zh_CN2["default"]);

exports["default"] = locale;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/antd/lib/time-picker/locale/zh_CN.js
 ** module id = 1452
 ** module chunks = 0
 **/